import { combineReducers } from 'redux';
import basket from './basket'
import auth from './auth'
import orders from './orders'
import finance from './finance'

export default combineReducers({  basket, auth, orders, finance });